<style scoped>
    .card {
        position: relative !important;
    }

    .card-image {
        padding: 24px 0 0 0
    }

    .card .card-image img {
        height: 150px !important;
        width: auto !important;
        margin: auto;
    }

    a.remove {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>

<template lang="pug">
    .card
        .card-image
            img(ref="photo")
        a.remove(href="#", v-on:click="removeProduct", v-if='removable === true')
            i.material-icons.red-text remove_circle_outline
        .card-content
            span.card-title {{this.product.name}}
            table.responsive-table.compact
                tbody
                    tr
                        td
                            strong
                                | Product Code
                        td {{this.product.productCode}}
                    tr
                        td
                            strong
                                | Category
                        td {{this.product.category}}
                    tr
                        td
                            strong
                                | Tag
                        td {{this.product.tags}}
                    tr
                        td
                            strong
                                | Bottler
                        td {{this.product.bottler}}
                    tr
                        td
                            strong
                                | Country
                        td {{this.product.country}}
                    tr
                        td
                            strong
                                | Region
                        td {{this.product.region}}

        .card-tabs
            ul.tabs(ref='tabs')
                li.tab(v-for="variant in product.variants", :variant="variant", :class='{active: activeTab === variant.variantCode}', @click='changePhoto(variant)')
                    a(:href="'#' + $utils.formatter.formatToHtmlId(variant.variantCode)") {{variant.variantCode}}
        .card-content.grey.lighten-4
            div(v-for="variant in product.variants", :variant="variant", :id="$utils.formatter.formatToHtmlId(variant.variantCode)")
                table.responsive-table.compact
                    tbody
                        tr
                            td
                                strong
                                    | Age
                            td {{variant.age ? variant.age + ' years' : 'Unavailable'}}
                        tr
                            td
                                strong
                                    | Price
                            td {{$utils.formatter.formatAmount(variant.price)}}
                        tr
                            td
                                strong
                                    | Volume
                            td {{variant.volumeCl}} CL
                        tr
                            td
                                strong
                                    | Alcohol Content
                            td {{variant.alcoholContent ? variant.alcoholContent + '%' : 'Unavailable'}}

</template>
<script>
import defaultPhoto from '../assets/default-no_prev.png'

export default {
  props: ['product', 'index', 'removable'],
  data () {
    return {
      activeTab: this.product.variants ? this.product.variants[0].variantCode : null
    }
  },
  mounted () {
    this.$M.Tabs.init(this.$refs.tabs)
    this.changePhoto(this.product.variants[0])
  },
  methods: {
    removeProduct (e) {
      e.preventDefault()
      this.$emit('removeProduct', this.product.productCode, this.index)
    },
    photoLoaded (e) {
      this.$refs.photo.src = e.target.result
    },
    changePhoto (variant) {
      if (typeof variant.photo === 'object') {
        const fileReader = new FileReader()
        fileReader.onload = this.photoLoaded
        fileReader.readAsDataURL(variant.photo)
      } else if (typeof variant.photo === 'string') {
        this.$refs.photo.src = variant.photo
      } else {
        this.$refs.photo.src = defaultPhoto
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-card-product.vue